import { Component, Input } from '@angular/core';

type SisChipTone = 'neutral' | 'success' | 'warning' | 'error' | 'info';

@Component({
  selector: 'app-sis-status-chip',
  templateUrl: './sis-status-chip.component.html',
  styleUrls: ['./sis-status-chip.component.css'],
  standalone: false
})
export class SisStatusChipComponent {
  @Input() tone: SisChipTone = 'neutral';
}
